import { DestroyRef, Injectable, inject, signal } from '@angular/core';

/** Un solo tic por segundo para todos los cronometros del KDS. */
@Injectable({ providedIn: 'root' })
export class CocinaRelojService {
  readonly ahora = signal(Date.now());

  constructor() {
    const intervalo = setInterval(() => this.ahora.set(Date.now()), 1000);
    inject(DestroyRef).onDestroy(() => clearInterval(intervalo));
  }
}
